
export default {
    name: "the-selection",
    props: {
        title: {
            required: true,
            default: ''
        },
        description: {
            required: false,
            default: ''
        },
        isProfile: {
            type: Boolean,
            required: false,
            default: false
        },
        subtitle: {
            required: false,
            default: ''
        },
        layout: {
            type: String,
            default: "chain",
            required: false,
        },
        oauthUrl: {
            Type: String,
            default: '',
            required: true
        }
    },
    data() {
        return {
            vippsIcon: require("../../../../../assets/img/vipps-logo-orange.png"),
            googleIcon: require("../../../../../assets/img/google-logo-login.svg"),
            appleIcon: require("../../../../../assets/img/apple-logo-black.svg"),
            fixitIcon: require('../../../../../assets/img/fixit-logo-white.png'),
        };
    },
    methods: {
        nextStep(state) {
            // Track selected method
            if (this.layout === 'portal' && !this.isProfile) {
                if (state === 'insert-email') {
                    window.CONFIG.google.sendEventButtonClick('create-new-user', 'Opprett ny bruker','' )
                }
            } 
            this.$emit("nextStep", state);
        },
        close() {
            this.$emit("close");
        },
        oauthCreate(type) {
            // Track selected method
            if (this.layout === 'portal' && !this.isProfile) {
                window.CONFIG.google.sendEventButtonClick('create-new-user-with-' + type, 'Opprett ny bruker med ' + type, '')
            } 
            let redirectUrl = window.location.origin + window.location.pathname;
            if (this.$route.query.action && this.$route.query.siteId && this.$route.query.customerId) {
              redirectUrl += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
            }
            window.location.href = this.oauthUrl + `?oauthTarget=${type}&redirectUri=${encodeURIComponent(redirectUrl)}`
            // setTimeout(() => {
            //     child.postMessage({returnMessageTo: window.location.origin}, this.oauthUrl)
            // }, 500);
        }
    },
    async beforeCreate() {
        window.addEventListener("message", (event) => {
            if(event.origin == this.oauthUrl){
                this.$emit("startEmailVerification", event);
            }
        }, false);
    }
};
